import {TransactionDate} from "../transaction/Transaction.types";
import dayjs from "dayjs";

export const getTransactionYear = <T extends TransactionDate>(come: T): number => {
	return dayjs(come.date).year();
}
